import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate, Navigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { setAnswer, getUsuario } from "../actions";

import { Container, Row, Col, Button } from "react-bootstrap";

const Equipo = (props) => {
  const dispatch = useDispatch();

  const [values, setValues] = useState({ consentimiento: 0 });

  const [submitted, setSubmitted] = useState(false);

  const usuario = useSelector((state) => state.usuario);

  return (
    <Container>
      <h3 className="mt-4">
        Identificación de Fortalezas del Rol SPS en Collahuasi
      </h3>
      <Row className="m-sm-5">
        <Col className="xz-texto-instr">
          <p className=" ">El plazo de participación ha terminado.</p>

          <p>
            En el caso que participaste en el proceso, y solamente para tu
            retroalimentación personal, recibirás un informe privado con la
            identificación de tus fortalezas a tu correo.
          </p>
          
        </Col>
      </Row>
    </Container>
  );
};

export default Equipo;
